<template>
  <v-card
    v-if="mostrar"
    outlined
    class="mt-3 pa-3"
    style="background:#f7fafc; border-left: 4px solid #00897b"
  >
    <div class="subtitle-2 font-weight-bold mb-2" style="color:#00695c">
      Información del alumno
    </div>
    <div v-if="cargando" class="caption grey--text">Cargando…</div>
    <template v-else-if="info">
      <div class="mb-1"><b>Matrícula:</b> {{ info.matricula || '—' }}</div>
      <div class="mb-1">
        <b>Ciclo actual:</b>
        {{ (info.ciclo_actual && info.ciclo_actual.ciclo) || 'Sin grupo en ciclo vigente' }}
      </div>
      <div class="mb-1">
        <b>Grupo:</b>
        {{ (info.ciclo_actual && info.ciclo_actual.grupo) || '—' }}
      </div>
      <v-alert
        v-if="info.grupos_ciclo_actual && info.grupos_ciclo_actual.length > 1"
        dense
        text
        type="info"
        class="mt-2 mb-0"
      >
        Tiene {{ info.grupos_ciclo_actual.length }} grupos en el ciclo vigente.
      </v-alert>
    </template>
    <div v-else-if="error" class="caption error--text">{{ error }}</div>
  </v-card>
</template>

<script>
export default {
  name: 'InfoAlumnoTicket',
  props: {
    mostrar: { type: Boolean, default: false },
    cargando: { type: Boolean, default: false },
    info: { type: Object, default: null },
    error: { type: String, default: '' },
  },
}
</script>
